import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const { lang } = useParams();
  const currentLang = lang || 'en';
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible) return null;

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 sm:p-6 bg-slate-900 border-t border-white/10 z-50 shadow-[0_-10px_40px_rgba(0,0,0,0.5)]">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-4 md:gap-8">
        <p className="text-xs text-white/70 flex-grow text-center md:text-left leading-relaxed">
          {t('cookie_text')}
          <Link to={`/${currentLang === 'en' ? '' : currentLang + '/'}privacy`} className="text-indigo-400 hover:text-indigo-300 underline underline-offset-2">
            {t('privacy_policy')}
          </Link>.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button 
            onClick={handleDecline}
            className="px-4 py-2 text-xs font-semibold text-white/70 hover:text-white bg-white/5 hover:bg-white/10 rounded-lg transition-colors"
          >
            {t('cookie_decline')}
          </button>
          <button 
            onClick={handleAccept}
            className="px-4 py-2 text-xs font-semibold text-slate-900 bg-white hover:bg-slate-200 rounded-lg transition-colors"
          >
            {t('cookie_accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
